import ExternalLink from "../../components/ExternalLink";
import { getExplorerLink } from "../../functions/explorer";
import { useActiveWeb3React } from "../../hooks/useActiveWeb3React";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import React, { useMemo } from "react";
import Image from "next/image";

export default function TransactionPopup({
  hash,
  success,
  summary,
}: {
  hash: string;
  success?: boolean;
  summary?: string;
}) {
  const { chainId } = useActiveWeb3React();

  const genSummary = useMemo(() => {
    return summary
      ? summary
      : `Hash: ${hash.slice(0, 8)}...${hash.slice(58, 65)}`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summary])

  return (
    <div
      className="flex flex-row w-full flex-nowrap"
      style={{ zIndex: 100000 }}
    >
      <div className="pr-4">
        {success ? (
          <Image src="/images/icons/icon-success.png" alt="success" width={59} height={59} />
        ) : (
          <Image src="/images/icons/icon-error.png" alt="error" width={59} height={59} />
        )}
      </div>
      <div className="flex flex-col">
        <div className="font-bold zText-1 text-base">
          {success ? " Success" : " Failed"}
        </div>
        <div className="zText-1">
          {genSummary}
        </div>
        {chainId && hash && (
          <ExternalLink
            className="p-0 text-blue hover:underline lg:p-0"
            href={getExplorerLink(chainId, hash, "transaction")}
          >
            <div className="flex flex-row items-center zText-1">
              View on explorer <ExternalLinkIcon width={20} height={20} />
            </div>
          </ExternalLink>
        )}
      </div>
    </div>
  );
}
